import { RHFInput } from '@talentmesh/ui/components/rhf-input';
import { TypographySmall } from '@talentmesh/ui/components/typography';
import EmailTemplatePlaceholders from '../../EmailTemplatePlaceholders';
import InfoTooltip from '@/Components/Tooltip/InfoTooltip';
import { useCompanyContext } from '@/Context/CompanyContext';
import UIStrings from '@/Utils/UIStrings';

interface SalutationProps {
    thankYouMessage: string;
}

const Salutation = ({ thankYouMessage }: SalutationProps) => {
    const { currentCompanyProfile } = useCompanyContext();
    const thankYouFullMessage = thankYouMessage.replace(
        EmailTemplatePlaceholders.CompanyName,
        currentCompanyProfile.companyName,
    );

    return (
        <>
            <div className="flex flex-row items-center justify-start gap-1">
                <div className="flex flex-row items-center justify-start gap-2">
                    <RHFInput fieldClassName="w-28" name="title" />
                    <TypographySmall className="whitespace-nowrap">{`${UIStrings.ApplicantsNamePlaceholder},`}</TypographySmall>
                </div>
                <InfoTooltip description={UIStrings.ApplicantNameTooltip} side="right" size="icon-xs" />
            </div>
            <TypographySmall className="pl-2">{thankYouFullMessage}</TypographySmall>
        </>
    );
};

export default Salutation;
